import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';

import reducers from './reducers/';
import sagas from './sagas';
import storeErrorReporter from './storeErrorReporter/storeErrorReporter';
import getComposeEnhancers from './storeExtensionSupporter/storeExtensionSupporter';
import storeLogger from './storeLogger/storeLogger';

export default (initialState) => {
    const sagaMiddleware = createSagaMiddleware();
    const middlewares = getMiddlewares(sagaMiddleware);
    const composeEnhancers = getComposeEnhancers();
    const enhancer = composeEnhancers(applyMiddleware(...middlewares));
    const store = createStore(reducers, initialState, enhancer);

    sagaMiddleware.run(sagas);

    return store;
};

function getMiddlewares(sagaMiddleware) {
    let middlewares = [sagaMiddleware];

    if (isRequiringExtraReporters()) {
        middlewares.push(storeErrorReporter);
        if (import.meta.env.REACT_APP_ENABLE_STORE_LOGGER === 'true') {
            middlewares.push(storeLogger);
        }
    }

    return middlewares;
}

function isRequiringExtraReporters() {
    return (
        import.meta.env.NODE_ENV === 'development' || window.STAGING_ENVIRONMENT
    );
}
